import { Alert } from "@abios/smorgasbord-components"
import styled from "styled-components"

export const StyledAlert = styled(Alert)`
  flex-grow: 1;
`
